@if (location(); as location) {
  <div ngbDropdown
       class="ps-3">
    <div ngbDropdownToggle
         role="button">
      Room:
      @if (room(); as room) {
        <b>{{ room.Room }}</b>
      } @else {
        <b>Select</b>
      }
    </div>
    <div ngbDropdownMenu>
      <a ngbDropdownItem
         (click)="openAddRoomModal()"> Add room </a>
      @for (room of rooms(); track room) {
        <a ngbDropdownItem
           [routerLink]="[room.Room]"> Room {{ room.Room }} </a>
      }
    </div>
  </div>
}